// Economics (TX-US-0025): what is on offer, one button each. The models are the API's catalogue
// and nothing here names one; the fleet requirement calculator (TX-US-0030) is not a model - it
// has no scenarios - and is the one entry this screen spells.

import { useEffect, useState } from 'react';
import { Link } from 'react-router';

import { listEconomicModels } from '../api.js';
import { DEFAULT_SCENARIO, scenarioPath } from './ScenarioScreen.jsx';

export default function EconomicsHome() {
  const [models, setModels] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    listEconomicModels().then(setModels).catch((err) => setError(err.message));
  }, []);

  if (error) return <p className="error">{error}</p>;
  if (!models) return <p className="empty">Loading…</p>;

  return (
    <section>
      <h2>Economics</h2>
      <p className="hint">
        Model a trade before it is a deal: shape the payment terms and timelines of the buyer and
        supplier POs until the cash stays positive.
      </p>
      <ul className="econ-models">
        {models.map((m) => (
          <li key={m.model_id}>
            <Link className="econ-model" to={scenarioPath(m.model_id, DEFAULT_SCENARIO)}>
              <strong>{m.name}</strong>
              <span>{m.description}</span>
            </Link>
          </li>
        ))}
        <li>
          <Link className="econ-model" to="/economics/fleet">
            <strong>Fleet requirement calculator</strong>
            <span>
              The trucks a route needs, from its cycle time, truck capacity and monthly target.
            </span>
          </Link>
        </li>
      </ul>
    </section>
  );
}
